import { ApolloClient, InMemoryCache, ApolloLink, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { get } from 'lodash'

import { appConfig } from '../config'
import { clearAuthState, getValidAccessToken } from '../features/auth'
import { typePolicies } from './typePolicies'
const httpLink = createHttpLink({
	uri: appConfig.graphqlEndpoint,
})

const authLink = setContext(async (_, { headers }) => {
	// get the authentication token from local storage if it exists

	const accessToken = await getValidAccessToken()
	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			authorization: accessToken ? `Bearer ${accessToken}` : '',
		},
	}
})

const unauthorizedLink = onError(error => {
	const { location } = window
	const statusCode = get(error, 'networkError.statusCode', 200)
	const errorMessage = get(error, 'graphQLErrors.0.message', undefined)
	const isOnLoginPage = location.pathname === '/login'
	// If token expired
	if (
		(statusCode === 401 || ['IDENTITY_EXPIRED_TOKEN'].includes(errorMessage)) &&
		!isOnLoginPage
	) {
		clearAuthState()
		location.href = `${location.origin}/login?${new URLSearchParams({
			redirectUrl: location.pathname + location.search,
		}).toString()}`
	}
})

export const client = new ApolloClient({
	link: ApolloLink.from([authLink, unauthorizedLink, httpLink]),
	cache: new InMemoryCache({
		typePolicies,
	}),
})
